<template>
    <div>
        <div class="section section-xl card-style-bottom-left card-3d-bottom bg-lighter bg-image"
            style="background-image: url('assets/images/blank-background.png');">
            <div class="container">
                <div class="d-flex align-items-center justify-content-center mt-4">
                    <img src="assets/images/notfound.svg" class="mx-2 notfound-img">
                </div>
                <div class="row justify-content-center mt-3">
                    <div class="col-md-6 text-center">
                        <h1 class="font-weight-boldermb-3 mt-3">Halaman tidak ditemukan</h1>
                        <p>
                            Mohon maaf halaman yang kamu cari tidak ditemukan.<br/>
                            Apabila kamu butuh bantuan silakan hubungi kami.
                        </p>
                        <router-link :to="{ name : 'home'}" class="btn btn-primary btn-block">Kembali ke halaman utama</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound',
        metaInfo: {
            title: 'Gubuk Sains Prima',
            titleTemplate: '%s — Halaman Tidak Ditemukan'
        },
    }
</script>